import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const Submenu = ({ reportsData }) => {
  const fetchAndConvertToCSV = () => {
    if (!reportsData) {
      console.error("No reports data provided.");
      return;
    }
    try {
      let dataToConvert;

      if (Array.isArray(reportsData)) {
        dataToConvert = reportsData;
      } else if (typeof reportsData === 'object' && reportsData !== null) {
        // Convert object into an array containing a single object
        dataToConvert = [reportsData];
      } else {
        console.error("Reports data is neither an array nor a valid object.", reportsData);
        return;
      }

      // If dataToConvert is empty, throw an error
      if (dataToConvert.length === 0) {
        console.warn("Reports data is empty.");
        return;
      }

      // Convert to CSV
      const csv = arrayToCSV(dataToConvert);
      downloadCSV(csv, "EventDetails.csv"); // Download the CSV
    } catch (error) {
      console.error("Error processing data:", error);
    }
  };
  const arrayToCSV = (data) => {
    const csvRows = [];
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(",")); // Add headers

    // Loop through each row of the data
    data.forEach((row) => {
      const values = headers.map((header) => {
        const val = row[header];
        // If value is an object or array, stringify it
        if (typeof val === 'object' && val !== null) {
          return `"${JSON.stringify(val).replace(/\r\n/g,' ').replace(/\r/g,' ').replace(/\n/g,' ').replace(/"/g, '""')}"`;
        } else {
          // Ensure that strings are escaped properly
          return typeof val === "string" ? `"${val.replace(/\r\n/g,' ').replace(/\r/g,' ').replace(/\n/g,' ').replace(/"/g, '""')}"` : val ?? '';
        }
      });
      csvRows.push(values.join(","));
    });

    return csvRows.join("\n");
  };

  // Function to download the CSV file
  const downloadCSV = (csv, filename) => {
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="container-fluid">
      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/js/bootstrap.bundle.min.js" integrity="sha384-YvpcrYf0tY3lHB60NNkmXc5s9fDVZLESaAA55NDzOxhy9GkcIdslK1eN7N6jIeHz" crossOrigin="anonymous"></script>

      <div className="menu-card-container">
        <div className="menucards">
          <nav className="navbar navbar-expand-lg navbar-light bg-light custom nav-underline.custom-nav-link">
            <a className="navbar-brand" href="">
              Reports
            </a>

            <div className="collapse navbar-collapse d-flex justify-content-between" id="navbarNavDropdown">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <NavLink
                    end
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                    to={"/eventReport"}
                  >
                    Events
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    end
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                    to={"/touchesReport"}
                  >
                    Touches
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to={"/siteReport"}
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                  >
                    Site
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    to={"/anniversaryReport"}
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                  >
                    Anniversary
                  </NavLink>
                </li>
              </ul>
              <button
                className="buttonrequest btn btn-success"
                onClick={fetchAndConvertToCSV}
              >
                <FontAwesomeIcon icon={faDownload} /> EXPORT IN .CSV
              </button>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Submenu;
